import React, { memo } from "react";

const ApplicationIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 0.5C1.79086 0.5 0 2.29086 0 4.5V12.5C0 14.7091 1.79086 16.5 4 16.5H12C14.2091 16.5 16 14.7091 16 12.5V4.5C16 2.29086 14.2091 0.5 12 0.5H4ZM5 5.06665C5 5.89508 4.32843 6.56665 3.5 6.56665C2.67157 6.56665 2 5.89508 2 5.06665C2 4.23822 2.67157 3.56665 3.5 3.56665C4.32843 3.56665 5 4.23822 5 5.06665ZM6 5.06665C6 4.23822 6.67157 3.56665 7.5 3.56665H12.5C13.3284 3.56665 14 4.23822 14 5.06665C14 5.89508 13.3284 6.56665 12.5 6.56665H7.5C6.67157 6.56665 6 5.89508 6 5.06665Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { ApplicationIcon };
